import {
  Grid
} from '@material-ui/core';
import PropTypes from 'prop-types';
import type { FC, ReactNode } from 'react';

interface GridProps {
  children: ReactNode;
  [key: string]: any
}

const FullGrid: FC<GridProps> = ({ children, ...other }) => (
  <Grid
    item
    md={12}
    xs={12}
    {...other}
  >
    {children}
  </Grid>
);

FullGrid.propTypes = {
  children: PropTypes.node
};

export default FullGrid;
